import React, { Component } from 'react';
import './luckyButton.css';

class LuckyButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchRandom: props.searchRandom
        }
    }

    render() {
        return (
            <button className="luckyButton"
                onClick={this.state.searchRandom}>
                I'm Feeling Lucky
            </button>
        );
    }
}

export default LuckyButton;